import { getSalesOrderControllerGetSalesOrderNotesQueryOptions } from '@/generated/api/sales-order.ts';
import { useQuery } from '@tanstack/react-query';

export default function useSalesOrderNotes(salesOrderId?: string) {
  return useQuery(
    getSalesOrderControllerGetSalesOrderNotesQueryOptions(salesOrderId ?? '', {
      query: { enabled: Boolean(salesOrderId) },
    }),
  );
}
